import { render, staticRenderFns } from "./StoreUpdatePMPhase.vue?vue&type=template&id=504095fe&scoped=true&"
import script from "./StoreUpdatePMPhase.vue?vue&type=script&lang=ts&"
export * from "./StoreUpdatePMPhase.vue?vue&type=script&lang=ts&"
import style0 from "./StoreUpdatePMPhase.vue?vue&type=style&index=0&id=504095fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504095fe",
  null
  
)

export default component.exports